module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-follow-btn",
    class: [("is_" + _vm.theme)]
  }, [_c('v-btn', {
    staticClass: "follow-btn",
    class: {
      'follow-btn': true,
      follow: !_vm.userIsFollowing,
      following: _vm.userIsFollowing,
      btnBlock: _vm.btnBlock,
      borderRadius: _vm.borderRadius,
    },
    staticStyle: {
      "background-color": "red"
    },
    on: {
      "mouseenter": function($event) {
        _vm.buttonHover = true
      },
      "mouseleave": function($event) {
        _vm.buttonHover = false
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.followUser()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.followButtonText) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0edd835e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userFollowBtn.vue
// module id = 1611
// module chunks = 180